<div class="color">
    <div class="container">
        <div class="text">
            <h1>Hire A Lean Leader</h1>
            <p>
                Hire a Lean Leader – we will act as change agent in your company
                during a limited period. There can be a need for special
                competence while you are recruiting or you simply need to speed
                up improvement pace in your company. Scope and duration will
                match your business needs.
            </p>
        </div>
        <img src="lean-thinking.png" alt="lean" />
    </div>
</div>

<style>
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 100px;
        padding-bottom: 200px;
        max-width: 800px;
    }
    @media screen and (max-width: 900px) {
        .container {
            padding-bottom: 100px !important;
        }
        h1 {
            font-size: 3em !important;
        }
    }
    .color {
        background-color: whitesmoke;
    }
    h1 {
        font-size: 4em;
    }

    img {
        padding-top: 50px;

        image-rendering: -webkit-optimize-contrast;
    }
</style>
